export const getDetailsTabStyles = () => ({
    content: {
        marginBottom: 70,
    },
});
